(function () {
  function getAgreementBlock() {
    return document.querySelector('[js-cart-subscription-agreement]');
  }

  function getCheckoutButton() {
    return document.querySelector('[js-cart-checkout-btn]');
  }

  function updateCheckoutState() {
    const agreement = getAgreementBlock();
    const checkoutBtn = getCheckoutButton();
    if (!checkoutBtn) return;

    if (!agreement) {
      checkoutBtn.disabled = false;
      return;
    }

    const checkbox = agreement.querySelector('[js-cart-subscription-checkbox]');
    checkoutBtn.disabled = !(checkbox && checkbox.checked);
  }

  function bindAgreementControls() {
    const agreement = getAgreementBlock();
    if (!agreement || agreement.dataset.bound === 'true') return;

    const checkbox = agreement.querySelector('[js-cart-subscription-checkbox]');
    if (!checkbox) return;

    agreement.dataset.bound = 'true';
    checkbox.addEventListener('change', updateCheckoutState);
    updateCheckoutState();
  }

  function bindPolicyTriggers() {
    document.querySelectorAll('[js-cart-cancellation-policy-trigger]').forEach((trigger) => {
      if (trigger.dataset.bound === 'true') return;
      trigger.dataset.bound = 'true';
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        HELPER_UTIL.dispatchCustomEvent(_EVENT_HELPER.showPopup, trigger, {
          popupType: 'cart-cancellation-policy-popup',
        });
        window.currentActiveElement = trigger;
      });
    });
  }

  function bindCheckoutFormGuard() {
    const form = document.querySelector('[js-cart-checkout-form]');
    if (!form || form.dataset.bound === 'true') return;

    form.dataset.bound = 'true';
    form.addEventListener('submit', (event) => {
      const agreement = getAgreementBlock();
      if (!agreement) return;

      const checkbox = agreement.querySelector('[js-cart-subscription-checkbox]');
      const submitter = event.submitter;
      const isCheckoutSubmit =
        submitter && submitter.getAttribute('name') === 'checkout';

      if (isCheckoutSubmit && (!checkbox || !checkbox.checked)) {
        event.preventDefault();
      }
    });
  }

  function initCartSubscriptionCheckout() {
    bindAgreementControls();
    bindPolicyTriggers();
    bindCheckoutFormGuard();
    updateCheckoutState();
  }

  document.addEventListener('DOMContentLoaded', initCartSubscriptionCheckout);

  if (typeof _EVENT_HELPER !== 'undefined') {
    document.addEventListener(_EVENT_HELPER.triggerCartChange, () => {
      const agreement = getAgreementBlock();
      if (agreement) agreement.dataset.bound = 'false';

      const form = document.querySelector('[js-cart-checkout-form]');
      if (form) form.dataset.bound = 'false';

      document.querySelectorAll('[js-cart-cancellation-policy-trigger]').forEach((el) => {
        el.dataset.bound = 'false';
      });

      initCartSubscriptionCheckout();
    });
  }
})();
